export default __webpack_public_path__ + "static/media/00.071745f8.jpg";